import React, { memo, useEffect, useState } from 'react';
import { mapCountryListForSelect, getCountry } from './Functions';
import { ServiceClient } from '../../Services/ServiceClient';
import Select from '../ids/InputElements/Select';
import { PresentationMode } from '../../Enums/PresentationMode';
import LoaderComponent from '../ids/Loader';

const CountrySelector = ({ cssClasses, onChange, defaultCountryCode, label, countryListFilled, isMandatory }) => {
  const [countryList, setCountryList] = useState(countryListFilled ?? []);
  const [mode, setMode] = useState(countryListFilled ? PresentationMode.View : PresentationMode.Loading);

  useEffect(() => {
    if (mode === PresentationMode.Loading) {
      ServiceClient.getCountries(countries => {
        setCountryList(countries);
        setMode(PresentationMode.View);
      });
    }
  }, [mode]);

  return (
    <>
      {mode === PresentationMode.Loading ? (
        <LoaderComponent />
      ) : (
        <Select
          label={label}
          defaultValue={defaultCountryCode}
          options={mapCountryListForSelect(countryList)}
          cssClasses={cssClasses}
          onChange={e => {
            onChange(getCountry(e.target.value, countryList));
          }}
          isMandatory={isMandatory}
        />
      )}
    </>
  );
};

export default memo(CountrySelector);
